import { UploadOutlined } from '@ant-design/icons';
import { FormHandler } from '@framework/form/form/FormHandler.tsx';
import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useFormItemEnabled } from '@framework/form/item/useFormItemEnabled.ts';
import { ModalDialog } from '@framework/ui/components/modal/ModalDialog.tsx';
import { Button, Spin, Tooltip } from 'antd';
import type * as React from 'react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type Subject } from 'rxjs';
import { type MapSubjectEvent } from '../../MapWidgetComponent.tsx';
import { MapUploadGeometriesGeoJSONInput } from './MapUploadGeometriesGeoJSONInput.tsx';
import { MapUploadGeometriesSchema } from './MapUploadGeometriesSchema.tsx';
import { MapUploadGeometriesShapefileInput } from './MapUploadGeometriesShapefileInput.tsx';

export interface IMapUploadGeometriesControlProps {
  mapSubject: React.RefObject<Subject<MapSubjectEvent>>;
}

export function MapUploadGeometriesControl(
  props: IMapUploadGeometriesControlProps,
) {
  const { mapSubject } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const initialValues = useMemo(() => {
    return MapUploadGeometriesSchema.cast({}, { assert: false });
  }, []);

  const { visuallyDisabled } = useFormItemEnabled();

  return (
    <div>
      <Tooltip title="Carica geometrie da file GeoJSON o Shapefile">
        <Button
          type="default"
          disabled={visuallyDisabled}
          style={{ borderWidth: '1px' }}
          onClick={() => setIsOpen(true)}
          icon={
            <UploadOutlined aria-label="Carica geometrie da file GeoJSON o Shapefile" />
          }
        />
      </Tooltip>
      <ModalDialog
        title="Carica Geometrie"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        size="small"
        cancelText={t('map-upload-geometries.chiudi', 'Chiudi')}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <div>
          <Spin spinning={loading} size="large">
            <FormHandler
              nested
              schema={MapUploadGeometriesSchema}
              initialValues={initialValues}
              onSubmit={() => {}}
            >
              <FormItem
                name="type"
                label="Tipo di geometria"
                layout={{ hideVisualLabel: true }}
              >
                <RadioGroupInput
                  name="type"
                  buttonStyle="solid"
                  optionType="button"
                  options={[
                    { label: 'GeoJSON', value: 'geojson' },
                    { label: 'Shapefile', value: 'shapefile' },
                  ]}
                />
              </FormItem>

              <MapUploadGeometriesGeoJSONInput
                mapSubject={mapSubject}
                onClose={() => setIsOpen(false)}
                onLoadingChange={setLoading}
              />

              <MapUploadGeometriesShapefileInput
                mapSubject={mapSubject}
                onClose={() => setIsOpen(false)}
                onLoadingChange={setLoading}
              />
            </FormHandler>
          </Spin>
        </div>
      </ModalDialog>
    </div>
  );
}
